module.exports = __webpack_public_path__ + "static/media/152.68fb7609.png";